import {FeaturesMenu, MenuNodeType} from '../../api/types/featuresMenu'

export const findFeatureByName = (featuresMenu: FeaturesMenu, featureName: string) => {
  const stack = [...featuresMenu]
  while (stack.length) {
    const current = stack.pop()
    if (!current) continue

    if (current.type === MenuNodeType.Feature && current.name === featureName) {
      return current
    }

    if (current.type === MenuNodeType.Folder) {
      stack.push(...current.children)
    }
  }
  return null
}
